import Select from "react-select";
import { useEffect } from "react";
import { handleSelectedMaterialAction, handleDataLoadingAction, getDataByReportTypeAction,getMaterialOptionAction } from '../../../store/actions/ReportActions';
import { connect, useDispatch } from 'react-redux';


const MaterialType = ({ selectedMaterial, materialOtions }) => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getMaterialOptionAction())
    }, [dispatch])
    return (
        <div style={{ minWidth: '12rem' }} className="mx-2">
            <label className="form-label">Select Material</label>
            <Select
                value={selectedMaterial}
                onChange={(data) => {
                    dispatch(handleSelectedMaterialAction(data))
                    dispatch(handleDataLoadingAction(true))
                    dispatch(getDataByReportTypeAction())
                }}
                isMulti={true}
                placeholder={"Choose Material"}
                className='react-select'
                classNamePrefix='select'
                styles={{ minWidth: '10rem' }}
                options={materialOtions}
            />
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        selectedMaterial: state.report.selectedMaterial,
        materialOtions: state.report.materialOtions
    };
};
export default connect(mapStateToProps)(MaterialType);